// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"271":"987b228d","347":"b3714dba","432":"41290a5b","649":"d5ed1b93","727":"1a953f42","765":"baea5c28","820":"0a6736d9","949":"3a7680b2"}[chunkId] + ".chunk.css";
};